/*
 * $Id:: FilterChips.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

import { ReactComponent as CancelIcon } from '../../assets/images/cancel_icon.svg';
import { bareDateTimeFormat, t } from '../../providers';

const useStyles = makeStyles((theme) => ({
    filters: {
        display: 'flex',
        flexFlow: 'row wrap',
        '@media (max-width:960px)': {
            paddingBottom: '15px',
        },
    },
    filterLabel: {
        fontSize: '0.75rem',
        fontWeight: '600',
        color: theme.palette.text.tableValue,
        marginRight: '6px',
        marginTop: '3px',
    },
    filterItem: {
        marginRight: '12px',
        fontSize: '0.875rem',
        color: theme.palette.text.mainGreen,
        fontWeight: 'normal',
        letterSpacing: '0.25px',
        lineHeight: '22px',
    },
    clearButton: {
        color: theme.palette.text.mainGreen,
        margin: '0px',
        border: '1px solid #3F5E20',
        boxSizing: 'border-box',
        borderRadius: '12px',
        padding: '0px 2px 0px 9px',
        height: '20px',
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D !important',
            borderRadius: '3px',
        },
        '& path': {
            fill: theme.palette.text.mainGreen,
        },
    },
    clearText: {
        marginLeft: '5px',
        marginRight: '7px',
        letterSpacing: '0.25px',
        fontWeight: 'normal',
        lineHeight: '14px',
    },
}));
const FilterChips = ({ filteredBy, onClearFilters, onFilterChange, onDateFilterChange }) => {
    const classes = useStyles();

    const addNiceClass = (str) => `${t('filter.nice.class')} ${str}`;
    const addLocarnoClass = (str) => `${t('filter.locarno.class')} ${str}`;
    const filters = Object.keys(filteredBy || {}).reduce((acc, cur) => {
        if (cur === 'searchQuery') {
            return acc;
        }

        let filts = filteredBy[cur];
        if (cur === 'classes') {
            filts = filteredBy[cur].map(addNiceClass);
        } else if (cur === 'locarno') {
            filts = addLocarnoClass(filteredBy[cur]);
            return [...acc, filts];
        } else if (cur === 'ipRightType') {
            filts = filteredBy[cur];
            return [...acc, filts];
        } else if (cur === 'dates') {
            filts = filteredBy[cur].filter((dr) => !!dr.dateType && !!dr.startDate && !!dr.endDate);
            if (!filts.length) {
                return acc;
            }
            return [
                ...acc,
                ...filts.map(
                    (dr) => `${t(dr.dateTypeLabel)} (${bareDateTimeFormat(dr.startDate, 'dd/mm/YY')} - ${bareDateTimeFormat(dr.endDate, 'dd/mm/YY')})`
                ),
            ];
        }

        return [...acc, ...(filts || [])];
    }, []);

    return (
        filters.length && (
            <div className={classes.filters} aria-orientation="horizontal" aria-expanded="false" role="">
                <span className={classes.filterLabel}>{t('filtered.by')}:</span>
                {Object.keys(filteredBy || {}).map((fltr, idx) => (
                    <span key={`${fltr}_${idx}`} className={classes.filterItem}>
                        <span style={{ fontSize: '0.875rem', color: '#5D5D5D', fontWeight: '600', letterSpacing: '0.25px', paddingRight: '7px' }}>
                            {t(`${fltr}.filters.description`)}
                        </span>
                        {filteredBy[fltr].map((flt, idx) =>
                            fltr !== 'dates' ? (
                                <span key={`${flt}_${idx}`}>
                                    {flt}
                                    <Button
                                        disableFocusRipple
                                        style={{ margin: '0px', padding: '0px', border: 'none', marginRight: '7px', marginTop: '-2px' }}
                                        id={`filters-clear-btn-${flt}-${idx}`}
                                        className={classes.clearButton}
                                        onClick={() => onFilterChange({ target: { name: fltr, value: filteredBy[fltr] } }, flt)}
                                        aria-label={t('remove.filter')
                                            .replace('{filterName}', t(`${fltr}.filters.description`))
                                            .replace('{filterOption}', filteredBy[fltr])}>
                                        <CancelIcon focusable="false" aria-hidden="true" />
                                    </Button>
                                </span>
                            ) : (
                                <span key={`${flt.dateTypeLabel}_${idx}`}>
                                    {`${t(flt.dateTypeLabel)} (${bareDateTimeFormat(flt.startDate, 'dd/mm/YY')} - ${bareDateTimeFormat(
                                        flt.endDate,
                                        'dd/mm/YY'
                                    )})`}
                                    <Button
                                        disableFocusRipple
                                        style={{ margin: '0px', padding: '0px', border: 'none', marginRight: '7px', marginTop: '-2px' }}
                                        id={`filters-clear-btn-${flt}-${idx}`}
                                        className={classes.clearButton}
                                        onClick={() => onDateFilterChange(flt.dateType, idx, filteredBy[fltr])}
                                        aria-label={t('remove.filter', { filterName: flt.dateType, filterOption: filteredBy[fltr] })}>
                                        <CancelIcon aria-hidden="true" focusable="false" />
                                    </Button>
                                </span>
                            )
                        )}
                        <span style={{ color: '#5D5D5D' }}>|</span>
                    </span>
                ))}
                <Button disableFocusRipple id={'filters-clear-btn'} className={classes.clearButton} onClick={onClearFilters}>
                    <span className={classes.clearText}>{t('clearAllText')}</span>
                </Button>
            </div>
        )
    );
};

export default FilterChips;
